export default {"src":"/_next/static/media/no-plan.3a14d7f2.svg","height":217,"width":397,"blurWidth":0,"blurHeight":0};